// Firebase kullanıyoruz, callback gerekmiyor - direkt login sayfasına yönlendir
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/admin/login');
  }, [navigate]);

  return null;
};

export default AdminCallback;
